"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _Markdown = require("./Markdown");

var _Markdown2 = _interopRequireDefault(_Markdown);

var _util = require("../util");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Expando = function Expando(_ref) {
  var _ref$Markdown = _ref.Markdown,
      Markdown = _ref$Markdown === undefined ? _Markdown2.default : _ref$Markdown,
      expanded = _ref.expanded,
      is_self = _ref.is_self,
      body = _ref.selftext,
      html = _ref.selftext_html;
  return _react2.default.createElement(
    "div",
    { className: "expando" },
    expanded ? is_self && body ? _react2.default.createElement(
      "form",
      { className: "usertext warn-on-unload" },
      (0, _util.optional)(Markdown, { body: body, html: html, className: "usertext-body may-blank-within md-container" })
    ) : null : null
  );
};

exports.default = Expando;


//////////////////
// WEBPACK FOOTER
// ./node_modules/snew-classic-ui/build/components/Expando.js
// module id = 303
// module chunks = 0